/**
 * Environments
 */

const BASE_URL = `${window._env_.REACT_APP_BASE_URL}`;
const GEO_API_URL = `${window._env_.REACT_APP_GEO_API_URL}`;
const MAP_DARK_LAYER_URL = `${window._env_.REACT_APP_MAP_DARK_LAYER_URL}`;
const MAP_LIGHT_LAYER_URL = `${window._env_.REACT_APP_MAP_LIGHT_LAYER_URL}`;
const MAP_SATELLITE_LAYER_URL = `${window._env_.REACT_APP_MAP_SATELLITE_LAYER_URL}`;
const MAP_HYBRID_LAYER_URL = `${window._env_.REACT_APP_MAP_HYBRID_LAYER_URL}`;
const KEYCLOAK_URL = `${window._env_.REACT_APP_KEYCLOAK_URL}`;
const KEYCLOAK_REALM = `${window._env_.REACT_APP_KEYCLOAK_REALM}`;
const KEYCLOAK_CLIENT_ID = `${window._env_.REACT_APP_KEYCLOAK_CLIENT_ID}`;

/**
 * Config object to export
 */

export default {
  // App Details
  appName: 'fansat-admin',
  appVersion: '1.1.22',
  app_id: 1,
  // Build Configuration - eg. Debug or Release?
  isDevEnv: process.env.NODE_ENV === 'development',
  ENV: process.env.NODE_ENV,

  // default location
  default_location: [32.665724, 51.664708],

  // Date Format
  dateFormat: 'DD MMM YYYY',

  // API
  apiBaseUrl: `${BASE_URL}/api`,
  mediaBaseUrl: `${BASE_URL}/api/file/download/`,
  authUrl: `${BASE_URL}/api/auth/token`,
  geoApiUrl: `${GEO_API_URL}`,
  keyclockInfo: {
    url: KEYCLOAK_URL,
    realm: KEYCLOAK_REALM,
    clientId: KEYCLOAK_CLIENT_ID,
  },
  mapUrls: {
    light: MAP_LIGHT_LAYER_URL,
    dark: MAP_DARK_LAYER_URL,
    satellite: MAP_SATELLITE_LAYER_URL,
    hybrid: MAP_HYBRID_LAYER_URL,
  },
};
